import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '@reducers/index';
import React from 'react';
import RateExtensionModal from '../../modals/rate-extension/RateExtensionModal';
import { FreeTrialDecisionPopup } from './FreeTrialDecisionPopup';
/** App-level popups that render outside the route tree. */
export function AppPopups() {
    var _a;
    const { user } = useAppSelector(state => ({ user: state.user }));
    return (_jsxs(_Fragment, { children: [_jsx(RateExtensionModal, {}), ((_a = envConfig.FEATURES) === null || _a === void 0 ? void 0 : _a.FREE_TRIAL_POPUP) && Boolean(user.id) && _jsx(FreeTrialDecisionPopup, {})] }));
}
